import React from 'react'
import { UserRoles } from 'constants/users'
import { useAuth0, User } from '@auth0/auth0-react'

export const getUserRoleByValue: any = (value: number) => {
  return UserRoles.find((role) => role.value === value || role.withoutEdit === value)
}

export const isUserAllowedToEdit: any = (value: number) => {
  const role: any = UserRoles.find((role) => role.value === value || role.withoutEdit === value)
  return role.value === value
}

export const getRoleValueByRoleKeyAndEdit: any = (roleKey: string, edit: boolean) => {
  const role: any = UserRoles.find((role) => role.key === roleKey)
  return edit ? role.value : role.withoutEdit
}

export const useGetUser = () => {
  const { user } = useAuth0()
  return user
}

export const useGetUserId = (user: User | undefined) => {
  const userId = user?.app_user_id
  return userId
}

export const useIsCustomerAccount = (user: User | undefined) => {
  const role = user?.role

  const isCustomerAccount = role === 'Customer'
  return isCustomerAccount
}

export const useIsServiceAccount = (user: User | undefined) => {
  const role = user?.role

  const isServiceAccount = role === 'Service'
  return isServiceAccount
}

export const useIsPartnerAccount = (user: User | undefined): boolean => {
  const role = user?.role

  const isPartnerAccount = role === 'Partner'
  return isPartnerAccount
}

export const useIsDealerAccount = (user: User | undefined) => {
  const role = user?.role

  const isDealerAccount = role === 'Dealer'
  return isDealerAccount
}

export const useIsMechanicAccount = (user: User | undefined) => {
  const role = user?.role

  const isMechanicAccount = role === 'Mechanic'
  return isMechanicAccount
}

export const useIsWorkerAccount = (user: User | undefined) => {
  const role = user?.role

  const isWorkerAccount = role === 'Worker'
  return isWorkerAccount
}

export const useIsRootAccount = (user: User | undefined) => {
  const role = user?.role
  const isRootAccount = role === 'Root'
  return isRootAccount
}

export const useGetUserGroups = (user: User | undefined) => {
  const role = user?.role
  return [role]
}

export const getUserInitialsAvatar = (user: User | undefined) => {
  const emailAddress = user?.email
  const emailAddressWithoutDomain = user && emailAddress?.split('@')?.[0]
  const emailAddressWithDots = user && emailAddressWithoutDomain?.split('.')

  const firstLetter = user?.name ? user.name.charAt(0) : user && emailAddressWithDots?.[0]?.charAt(0)
  const secondLetter = user?.family_name ? user.family_name.charAt(0) : user && emailAddressWithDots?.[1]?.charAt(0)

  return (
    <div className='user-initials'>
      <h1>
        {firstLetter && <span className='first'>{firstLetter}</span>}
        {secondLetter && <span className='second'>{secondLetter}</span>}
      </h1>
    </div>
  )
}
